import { defineMessages } from 'react-intl';

export default defineMessages({
  reviewYourServices: {
    id: 'src.pages.ServiceReview.reviewYourServices',
    defaultMessage: 'Review your services',
  },
  dateIncident: {
    id: 'src.pages.ServiceReview.dateIncident',
    defaultMessage: 'Date of incident:',
  },
  vehicle: {
    id: 'src.pages.ServiceReview.vehicle',
    defaultMessage: 'Vehicle:',
  },
  contact: {
    id: 'src.pages.ServiceReview.contact',
    defaultMessage: 'Contact:',
  },
  serviceSelection: {
    id: 'src.pages.ServiceReview.serviceSelection',
    defaultMessage: 'Service selection:',
  },
  audatargetSelection: {
    id: 'src.pages.ServiceReview.audatargetSelection',
    defaultMessage: 'Repair shop selection',
  },
  editCta: {
    id: 'src.pages.ServiceReview.editCta',
    defaultMessage: 'Edit',
  },
  servicetype: {
    id: 'src.pages.ServiceReview.servicetype',
    defaultMessage: 'Service type:',
  },
  servicetypeUber: {
    id: 'src.pages.ServiceReview.servicetypeUber',
    defaultMessage: 'Uber',
  },
  shop: {
    id: 'src.pages.ServiceReview.shop',
    defaultMessage: 'Shop:',
  },
  address: {
    id: 'src.pages.ServiceReview.address',
    defaultMessage: 'Address:',
  },
  scheduledFor: {
    id: 'src.pages.ServiceReview.scheduledFor',
    defaultMessage: 'Scheduled For:',
  },
  servicetypeEnterprise: {
    id: 'src.pages.ServiceReview.servicetypeEnterprise',
    defaultMessage: 'Enterprise car rental',
  },
  servicetypeNone: {
    id: 'src.pages.ServiceReview.servicetypeNone',
    defaultMessage: 'None',
  },
  servicetypeClaimProfessional: {
    id: 'src.pages.ServiceReview.servicetypeClaimProfessional',
    defaultMessage: 'Will speak with a claims team member',
  },
  servicetypeEnterpriseBranch: {
    id: 'src.pages.ServiceReview.servicetypeEnterpriseBranch',
    defaultMessage: 'Branch:',
  },
  servicetypeDetails: {
    id: 'src.pages.ServiceReview.servicetypeDetails',
    defaultMessage: 'Details:',
  },
  servicetypeDetailsUber: {
    id: 'src.pages.ServiceReview.servicetypeDetailsUber',
    defaultMessage: 'Voucher sent by Uber to',
  },
  consentFinal: {
    id: 'src.pages.ServiceReview.consentFinal',
    defaultMessage: 'I confirm that, to the best of my knowledge, the information being submitted is true and accurate. I understand that making a false or misleading statement may result in my claim or benefits being denied and may constitute an offence under provincial insurance legislation and the Criminal Code of Canada.',
  },
  continueCta: {
    id: 'src.pages.ServiceReview.continueCta',
    defaultMessage: 'Continue',
  },
  submitCta: {
    id: 'src.pages.ServiceReview.submitCta',
    defaultMessage: 'Submit',
  },
  informationSecure: {
    id: 'src.pages.ServiceReview.informationSecure',
    defaultMessage: 'Your information is secure.',
  },
  submit: {
    id: 'src.pages.ServiceReview.submit',
    defaultMessage: 'Submit',
  },
});
